"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiChargeComplaintResolveBulkDto = exports.BillingApiChargeComplaintResolveDto = void 0;
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
/**
 * Решение по жалобе
 */
let BillingApiChargeComplaintResolveDto = class BillingApiChargeComplaintResolveDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма возврата (так как возврат может быть частичным)",
  type: String,
  format: "decimal",
  pattern: "^d{1,}(.d{1,6})?$",
  example: "100.00",
  required: false,
  nullable: true
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsDecimal)({
  decimal_digits: "1,"
}), __metadata("design:type", Object)], BillingApiChargeComplaintResolveDto.prototype, "refundAmount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Процент возврата (так как возврат может быть частичным)",
  type: String,
  format: "decimal",
  pattern: "^d{1,}(.d{1,6})?$",
  example: "100.00",
  required: false,
  nullable: true
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsDecimal)({
  decimal_digits: "1,"
}), __metadata("design:type", Object)], BillingApiChargeComplaintResolveDto.prototype, "refundPercent", void 0);
BillingApiChargeComplaintResolveDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiChargeComplaintResolveDto);
exports.BillingApiChargeComplaintResolveDto = BillingApiChargeComplaintResolveDto;
/**
 * Решение по жалобе
 */
let BillingApiChargeComplaintResolveBulkDto = class BillingApiChargeComplaintResolveBulkDto extends BillingApiChargeComplaintResolveDto {};
__decorate([(0, class_transformer_1.Expose)(), (0, swagger_1.ApiProperty)({
  title: 'Id начисления',
  type: String,
  format: 'uuid'
}), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiChargeComplaintResolveBulkDto.prototype, "chargeId", void 0);
BillingApiChargeComplaintResolveBulkDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiChargeComplaintResolveBulkDto);
exports.BillingApiChargeComplaintResolveBulkDto = BillingApiChargeComplaintResolveBulkDto;
